import React, { useEffect, useRef } from "react";
import "../css/side.css";
import "../css/details.css";
import { Icon, D } from "../search/icons";

/**
 * Right-hand slide-over used for details and short forms (truck / load / order / company cards).
 * Escape or a click on the dim area closes it, focus moves into it and returns on close;
 * on phones it becomes a full-width sheet. Rendered inside the page so it inherits the page's CSS variables.
 */
export default function SidePanel({ title, subtitle, onClose, footer, wide = false, className = "", children }) {
  const root = useRef(null);
  useEffect(() => {
    const last = document.activeElement;
    root.current?.querySelector("[data-side-close]")?.focus();
    const onKey = (e) => {
      // a document viewer opened inside the panel handles its own Escape
      if (e.key === "Escape" && !document.querySelector("[data-doc-overlay]")) {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKey, true);
    return () => {
      document.removeEventListener("keydown", onKey, true);
      if (last && last.isConnected) last.focus();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="side-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <aside aria-label={title} aria-modal="true" className={`side-panel${wide ? " wide" : ""}${className ? ` ${className}` : ""}`} ref={root} role="dialog">
        <header className="side-head">
          <div>
            <h2>{title}</h2>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          <button aria-label="Закрыть" className="icon-button" data-side-close onClick={onClose} type="button">
            <Icon d={D.close} />
          </button>
        </header>
        <div className="side-body">{children}</div>
        {footer ? <footer className="side-foot">{footer}</footer> : null}
      </aside>
    </div>
  );
}

/** label / value rows used by the detail cards */
export function SideRows({ rows }) {
  return (
    <dl className="side-rows">
      {rows
        .filter((r) => r && r[1] != null && r[1] !== "")
        .map(([k, v]) => (
          <div key={k}>
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
    </dl>
  );
}

export const SideSection = ({ title, children }) => (
  <section className="side-section">
    {title ? <h3>{title}</h3> : null}
    {children}
  </section>
);
